<template>
  <div>
    <img class="m-b-15" src="../../../assets/images/modals/ico059.svg" alt="Set Delivery Details">
    <text-string label-id="txt363" class="m-b-10"/>
    <text-string label-id="txt364"/>
  </div>
</template>

<script>
  export default {
    name: "modal-view-pharmacy-orders-step-three"
  }
</script>

<style scoped>

</style>